document.addEventListener('DOMContentLoaded', function () {
  
  // Menu Hover Event
  menuHoverEvent();
  
  // featured collection swiper
  featuredCollectionSwiper();

  //collection sub-category slider
  collectionSubCategorySwiper();

  //contact form submit fucntion
  submitFormDataToZap();
  
  // mobile menu close button start
  var detailsContainer = document.querySelector('#Details-menu-drawer-container summary');
  var menuDrawer = document.querySelector('#menu-drawer summary');
  if (menuDrawer && detailsContainer) {
    menuDrawer.addEventListener('click', function (event) {
      event.preventDefault(); 
      detailsContainer.click();
    });
  }
  // mobile menu close button end

  
  // Accordion section
  const accordionTitles = document.querySelectorAll(".section-accordion-inner .accordion-title");
  const allPanels = document.querySelectorAll(".section-accordion-inner .panel");
  
  if (accordionTitles.length > 0 && allPanels.length > 0) {
    // Open the first accordion by default
    accordionTitles[0].classList.add("active");
    allPanels[0].style.maxHeight = allPanels[0].scrollHeight + "px";
  
    accordionTitles.forEach(title => {
      title.addEventListener("click", function () {
        const panel = this.nextElementSibling;
        if (!panel || !panel.classList.contains("panel")) return;
  
        // Close other panels
        allPanels.forEach(p => {
          if (p !== panel) {
            p.style.maxHeight = null;
          }
        });
  
        // Remove 'active' class from other titles
        accordionTitles.forEach(t => {
          if (t !== this) {
            t.classList.remove("active");
          }
        });
  
        // Toggle active class and open/close panel
        this.classList.toggle("active");
  
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }


  //  PDP page media gallery swiper
  productMediaGallery();

 //  pdp page accordion metafield html convert js
  let accBoxEle = document.querySelectorAll('.product__info-container .pdp-accordian, .product__inner-media-wrapper .pdp-accordian');
  if (accBoxEle.length) {
    accBoxEle.forEach(accordion => {
      const metadata = accordion.querySelector('.accordian-metadata');
      const metadataContent = accordion.querySelector('.accordian-metadata-content');
      const hasProdDescription = accordion.querySelector('.accordion-prod-description');

      if (hasProdDescription) {
        const innerContent = hasProdDescription.querySelector('.accordian-metadata');
        if (innerContent) {
          //innerContent.classList.remove('hidden');
          metadataContent.innerHTML = metadata.innerHTML;
          innerContent.remove();
        }
        return;
      }
      
      if (metadata && metadataContent) {
        metadataContent.innerHTML = metadata.textContent.trim();
        metadata.remove();
      }
    });
  }

    //Add on modal product slider
  addonProductsModalSlider();
  //Add on Accessories product slider
  addonProductsAccessoriesSlider()

  ;
  
});

function featuredCollectionSwiper() {
  const sectionEl = document.querySelectorAll('.featured-collection-section');
  if(!sectionEl.length) return;
  
  sectionEl.forEach((swiperEl, index) => {
      const swipers = swiperEl.querySelector('[data-featured-collection-swiper]');
      const nextBtn = swiperEl.querySelector('.swiper-button-next');
      const prevBtn = swiperEl.querySelector('.swiper-button-prev');
      const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');

      new Swiper(swipers, {
        slidesPerView: 1.15,
        spaceBetween: 12,
        navigation: nextBtn && prevBtn ? {
          nextEl: nextBtn,
          prevEl: prevBtn,
        } : undefined,
        scrollbar: scrollbarEl ? {
          el: scrollbarEl,
          draggable: true
        } : undefined,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 24
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 24
          }
        },
      });
  });
}

function collectionSubCategorySwiper() {
  const sectionEl = document.querySelector('[data-sub-category-grid]');
  if(!sectionEl) return;
  
  const nextBtn = sectionEl.closest('.header-collections-multicolumn').querySelector('.swiper-button-next');
  const prevBtn = sectionEl.closest('.header-collections-multicolumn').querySelector('.swiper-button-prev');
      
  new Swiper(sectionEl, {
    slidesPerView: 8,
    spaceBetween: 10,
    navigation: nextBtn && prevBtn ? {
      nextEl: nextBtn,
      prevEl: prevBtn,
    } : undefined,
    breakpoints: {
      1367: {
        slidesPerView: 10
      }
    },
    on: {
      init() {
        if(this.navigation?.nextEl){
          this.navigation?.nextEl.classList.remove('hidden');
        }
        if(this.navigation?.prevEl){
          this.navigation?.prevEl.classList.remove('hidden');
        }
      },
    }
  });
}


function productMediaGallery() {
  const thumbSwiperEle = document.querySelector(`.thumbnails-swiper`);
  const mainGallrySwiperEle = document.querySelector(`.product-media-swiper`);
  
  if(!thumbSwiperEle || !mainGallrySwiperEle) return;

  const thumbNextBtn = thumbSwiperEle.parentElement?.querySelector(`.button-next-bottom`) || null;
  const thumbPrevBtn = thumbSwiperEle.parentElement?.querySelector(`.button-prev-top`) || null;
  
  var thumbnailSwiper = new Swiper(thumbSwiperEle, {
    direction: 'vertical',
    spaceBetween: 12,
    slidesPerView: 5,
    watchSlidesProgress: true,
    freeMode: true,
    navigation: {
      nextEl: thumbNextBtn,
      prevEl: thumbPrevBtn
    }
  });

  window.GallrySwiper = new Swiper(mainGallrySwiperEle, {
    spaceBetween: 10,
    watchSlidesProgress: true,
    thumbs: {
      swiper: thumbnailSwiper
    },
    pagination: {
      el: ".product-media-swiper-pagination"
    },
    breakpoints: {
      1200: {
        pagination: false
      }
    }
  });
}



function toggleAccordion(element) {
  const openClass = "active";
  let mainParent, currentParent;
  
  if(element.closest('.pdp-accordian')){
    mainParent = document.querySelectorAll(".product-accordion--wrapper .pdp-accordian");
    currentParent = element.closest(".pdp-accordian");  
  }else if(element.closest('.variant-accordion')){
    mainParent = document.querySelectorAll(".product__info-container .variant-accordion");
    currentParent = element.closest(".variant-accordion");
  }else if(element.closest('.filter-accordion')){
    mainParent = document.querySelectorAll("#FacetFiltersFormMobile  .filter-accordion");
    currentParent = element.closest(".filter-accordion");
  }
  const content = currentParent.querySelector(".panel");

  if (currentParent.classList.contains(openClass)) {
    currentParent.classList.remove(openClass);
    currentParent.querySelector(".panel").style.maxHeight = "0px";
  } else {
    mainParent.forEach((e) => {
      if (e.classList.contains(openClass)) {
        e.classList.remove(openClass);
        e.querySelector(".panel").style.maxHeight = "0px";
      }
    });
    currentParent.classList.add(openClass);
    content.style.maxHeight = `${content.scrollHeight + 10}px`;
  }
}



// This runs ONCE on page load to open only `.variant-accordion`
// document.addEventListener("DOMContentLoaded", function() {
//   const variantAccordions = document.querySelectorAll(".variant-accordion");

//   variantAccordions.forEach((accordion) => {
//     const panel = accordion.querySelector(".panel");
//     accordion.classList.add("active");
//     if (panel) {
//       panel.style.maxHeight = `${panel.scrollHeight + 10}px`;
//     }
//   });
// });

function menuHoverEvent() {
  const headerMenuLists = document.querySelectorAll('header-menu > details');
  if(headerMenuLists.length){
    headerMenuLists.forEach(list => {
      //on hover
      list.addEventListener("mouseenter", (e) => {
        e.target.setAttribute('open','');
        if(e.target.querySelector('summary')){
          e.target.querySelector('summary').setAttribute('aria-expanded','true');
        }
      });
      //on hover out
      list.addEventListener("mouseleave", (e) => {
        headerMenuLists.forEach(list => {
          list.removeAttribute('open');
          if(list.querySelector('summary')){
            list.querySelector('summary').setAttribute('aria-expanded','false');
          }
        });
      });
    });
  }
}


function submitFormDataToZap(){
  const submitBtn = document.querySelector(`[data-form-submit-btn]`);
  if(!submitBtn) return;

  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const target = e.target;
    const form = target.closest('form');
    if(!form) return;

    const formSuccessMsgEle = form.querySelector(`[data-form-success-msg]`);
    const formErrorsMsgEle = form.querySelector(`[data-form-error-msg]`);

    //btn loading class
    target.classList.add('loading');
    target.querySelector('.loading__spinner')?.classList.remove('hidden');

    if (!form.checkValidity()) {
      console.log('Form is not valid. Please check the required fields.');
      form.reportValidity();
      submitBtn.classList.remove('loading');
      submitBtn.querySelector('.loading__spinner')?.classList.add('hidden');
      return;
    }

    const email = form.querySelector(`input[name="contact[email]"]`).value;
    const postcode = form.querySelector(`input[name="contact[postcode]"]`).value;
    const name = form.querySelector(`input[name="contact[Your Name]"]`).value;
    const company = form.querySelector(`input[name="contact[company]"]`).value;
    const telephone = form.querySelector(`input[name="contact[Phone no.]"]`).value;
    const comments = form.querySelector(`textarea[name="contact[Comment]"]`).value;

    const captureTrackingParams = () => {
      const params = new URLSearchParams(window.location.search);
      
      // Capture the click ID - only one should be present
      const clickId = params.get('gclid') || params.get('gbraid') || params.get('msclkid') || '';
      
      const tracking = {
        mitl_source: params.get('utm_source') || '',
        mitl_medium: params.get('utm_medium') || '',
        mitl_campaign: params.get('utm_campaign') || '',
        mitl_gclid: clickId  // This field will store whichever click ID is present
      };
      
      // Store in sessionStorage
      sessionStorage.setItem('trackingParams', JSON.stringify(tracking));
      
      // Optional: Store which type of click ID for internal analytics
      if (params.get('gclid')) tracking._clickIdType = 'gclid';
      else if (params.get('gbraid')) tracking._clickIdType = 'gbraid';
      else if (params.get('msclkid')) tracking._clickIdType = 'msclkid';
      
      return tracking;
    };


    const trakingData = captureTrackingParams();

    // data
    const data = {
      "fullname": name,
      "emailaddress1": email,
      "telephone1": telephone,
      "address1_postalcode": postcode,
      "companyname": company,
      "description": comments,
      "subject": "Web Form –",
      "websiteurl": window.location.href
    }

    const contactZapURL = `https://hooks.zapier.com/hooks/catch/10733537/u6et31p/`;
    const finalData = {...data, ...trakingData};

    //console.log('Form data and additional data:', finalData);

    try {
      const response = fetch(contactZapURL, {
        method: 'POST',        
        body: JSON.stringify({
          ...finalData,
          timestamp: new Date().toISOString(),
          shop_domain: window.Shopify.shop,
          page_url: window.location.href
        })
      });
      response.then(result =>{
        // console.log(`result >>`,result);
        if (result.ok) {
          form.reset();
          submitBtn.classList.remove('loading');
          submitBtn.querySelector('.loading__spinner')?.classList.add('hidden');
          if(formSuccessMsgEle) formSuccessMsgEle.classList.remove(`hidden`);
          if(formErrorsMsgEle) formErrorsMsgEle.classList.add(`hidden`);
        }else{
          submitBtn.classList.remove('loading');
          submitBtn.querySelector('.loading__spinner')?.classList.add('hidden');
          if(formSuccessMsgEle) formSuccessMsgEle.classList.add(`hidden`);
          if(formErrorsMsgEle) formErrorsMsgEle.classList.remove(`hidden`);  
        }
      });
    } catch (error) {
      console.error('Submission failed:', error);
      submitBtn.classList.remove('loading');
      submitBtn.querySelector('.loading__spinner')?.classList.add('hidden');
      if(formSuccessMsgEle) formSuccessMsgEle.classList.add(`hidden`);
      if(formErrorsMsgEle) formErrorsMsgEle.classList.remove(`hidden`);
    }

  });
}


function addonProductsModalSlider(){
  const addOnModalEle = document.querySelector(`.addon-modal .addon-modal-swiper`);
  if(!addOnModalEle) return;
  var swiper = new Swiper(addOnModalEle, {
    slidesPerView: 1.5,
    spaceBetween: 20,
    loop: false,
    navigation: false,
    pagination: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
}

function addonProductsAccessoriesSlider(){
  const addOnAccessoriesEle = document.querySelector(`.product-add-ons .addon-products-swiper`);
  if(!addOnAccessoriesEle) return;
  var swiper = new Swiper(addOnAccessoriesEle, {
        slidesPerView: 1.3,
        spaceBetween: 20,
        loop: false,
        navigation: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
      });
}

function litpdpAccordionFix() {
  function removeCorrectInstance() {
    var desktopWrapper = document.querySelector('.product__inner-media-wrapper');
    var mobileWrapper = document.querySelector('.product__inner-info-wrapper');

    if (!desktopWrapper || !mobileWrapper) return;

    // Reset: move any previously removed accordion back before re-evaluating
    // We work with data attributes to track state
    var desktopAccordion = desktopWrapper.querySelector('.accordion-app') 
      ? desktopWrapper.querySelector('.accordion-app').closest('.accordion-box') 
      : null;
    var mobileAccordion = mobileWrapper.querySelector('.accordion-app') 
      ? mobileWrapper.querySelector('.accordion-app').closest('.accordion-box') 
      : null;

    if (window.innerWidth >= 990) {
      // Desktop: remove mobile instance
      if (mobileAccordion) {
        mobileAccordion.parentNode.removeChild(mobileAccordion);
      }
      // Re-bind desktop modal interactions
      var modal = desktopWrapper.querySelector('#myModal-litpdf') || document.getElementById('myModal-litpdf');
      var btns = desktopWrapper.querySelectorAll('.myBtn-litpdf');
      var closeBtn = desktopWrapper.querySelector('#close-litpdf-btn') || document.getElementById('close-litpdf-btn');

      if (modal) {
        Array.prototype.forEach.call(btns, function(btn) {
          btn.onclick = function() {
            modal.style.display = 'block';
            var scrollToY = modal.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: scrollToY });
          };
        });
        if (closeBtn) {
          closeBtn.onclick = function() {
            modal.style.display = 'none';
          };
        }
        window.onclick = function(event) {
          if (event.target == modal) {
            modal.style.display = 'none';
          }
        };
      }
    } else {
      // Mobile: remove desktop instance
      if (desktopAccordion) {
        desktopAccordion.parentNode.removeChild(desktopAccordion);
      }
      // Re-bind mobile modal interactions
      var modal = mobileWrapper.querySelector('#myModal-litpdf') || document.getElementById('myModal-litpdf');
      var btns = mobileWrapper.querySelectorAll('.myBtn-litpdf');
      var closeBtn = mobileWrapper.querySelector('#close-litpdf-btn') || document.getElementById('close-litpdf-btn');

      if (modal) {
        Array.prototype.forEach.call(btns, function(btn) {
          btn.onclick = function() {
            modal.style.display = 'block';
            var scrollToY = modal.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: scrollToY });
          };
        });
        if (closeBtn) {
          closeBtn.onclick = function() {
            modal.style.display = 'none';
          };
        }
        window.onclick = function(event) {
          if (event.target == modal) {
            modal.style.display = 'none';
          }
        };
      }
    }
  }

  // Run on load
  removeCorrectInstance();

  // Run on resize without needing page refresh
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Reload page cleanly on breakpoint cross to reset LitPDF bindings
      var isMobile = window.innerWidth < 990;
      var wasMobile = document.body.getAttribute('data-was-mobile') === 'true';

      if (isMobile !== wasMobile) {
        document.body.setAttribute('data-was-mobile', isMobile);
        window.location.reload();
      }
    }, 300);
  });

  // Set initial state
  document.body.setAttribute('data-was-mobile', window.innerWidth < 990);
}